if (!customElements.get('genus-item')) {
  const STOREFRONT_TOKEN = window.STOREFRONT_TOKEN;
  const GRAPHQL_ENDPOINT = window.GRAPHQL_ENDPOINT;

  customElements.define(
    'genus-item',
    class GenusItem extends HTMLElement {
      constructor() {
        super();
          this.speciesElement = this.querySelector('.genus-item-species');
          this.hybridsElement = this.querySelector('.genus-item-hybrids');
          this.hybridsListElement = this.querySelector('.genus-item-hybrids-list');
          this._loaded = false;
          this._loadedHybrids = false;
          this._loading = false;
          this.arrowSvg = this.querySelector('.icon.icon-arrow');
          this.informationSvg = this.querySelector('.icon.icon-info-information');
          this.shopSvg = this.querySelector('.icon.icon-info-shop');
          this.onClick = this.onClick.bind(this);

          this.hybridsButton = this.querySelector('.button--hybrids');
          if (this.hybridsButton) {
              this.hybridsButton.addEventListener('click', async (event) => {
                  event.preventDefault();
                  event.stopPropagation();

                  const willOpen = !this.hybridsListElement.classList.contains('active');
                  this.hybridsListElement.classList.toggle('active');
                  this.hybridsButton.classList.toggle('active');

                  if (willOpen) {
                      if (!this._loadedHybrids) {
                          await this.fetchHybrids().catch(err => {
                              console.error(err);
                              this.renderError('Er ging iets mis bij het laden.');
                          });
                      } else {
                          this.hybridsListElement?.removeAttribute('hidden');
                      }
                  } else {
                      this.hybridsListElement?.setAttribute('hidden', '');
                  }
              });
          }
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

        async onClick(event) {
            event.preventDefault();

            if (!this.speciesElement && !this.hybridsElement) {
                return;
            }

            const willOpen = !this.classList.contains('active');
            this.classList.toggle('active');

            if (willOpen) {
                if (!this._loaded) {
                    await this.fetchSpecies().catch(err => {
                        console.error(err);
                        this.renderError('Er ging iets mis bij het laden.');
                    });
                } else {
                    this.speciesElement?.removeAttribute('hidden');
                    this.hybridsElement?.removeAttribute('hidden');
                }
            } else {
                this.speciesElement?.setAttribute('hidden', '');
                this.hybridsElement?.setAttribute('hidden', '');
            }
        }

        async fetchSpecies() {
            if (this._loaded) return;
            if (this._loading) return;
            this._loading = true;

            let handle = this.dataset.metaobjectHandle;
            let type = this.dataset.metaobjectType;
            let language = document.documentElement.lang.toUpperCase();

            const query = `
query Metaobjects ($input: MetaobjectHandleInput!) @inContext(language: `+ language +`) {
  metaobject(handle: $input) {
    id
    fields {
      key
      references (first: 250) {
         edges {
           node {
             ... on Metaobject {
               id
               handle
               type
               onlineStoreUrl
               fields {
                 key
                 value
                 reference {
                   ... on MediaImage {
                     id
                   }
                 }
               }
             }
           }
         }
      }
      type
      value
    }
  }
}
              `;

            fetch(GRAPHQL_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
                },
                body: JSON.stringify({
                    query,
                    variables: {
                        "input": {
                            "handle": handle,
                            "type": type
                        }
                    }
                })
            })
                .then(res => res.json())
                .then(json => {
                    this._loaded = true;
                    let genusMetaobject = json.data.metaobject;

                    for (let i = 0; i < genusMetaobject.fields.length; i++) {
                        let field = genusMetaobject.fields[i];

                        if (field.key === 'list_species') {
                            for (let y = 0; y < field.references.edges.length; y++) {
                                let specie = field.references.edges[y].node;
                                this.speciesElement.appendChild(this.createSpecieHtml(specie));
                            }
                            this.updateShopIcons(this.speciesElement);
                        }
                    }

                    this._loading = false;
                }).catch(err => console.error(err));
        }

        async fetchHybrids() {
            if (this._loadedHybrids) return;
            if (this._loading) return;
            this._loading = true;

            let handle = this.dataset.metaobjectHandle;
            let type = this.dataset.metaobjectType;
            let language = document.documentElement.lang.toUpperCase();

            const query = `
query Metaobjects ($input: MetaobjectHandleInput!) @inContext(language: `+ language +`) {
  metaobject(handle: $input) {
    id
    fields {
      key
      references (first: 250) {
         edges {
           node {
             ... on Metaobject {
               id
               handle
               type
               onlineStoreUrl
               fields {
                 key
                 value
                 reference {
                   ... on MediaImage {
                     id
                   }
                 }
               }
             }
           }
         }
      }
      type
      value
    }
  }
}
              `;

            fetch(GRAPHQL_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
                },
                body: JSON.stringify({
                    query,
                    variables: {
                        "input": {
                            "handle": handle,
                            "type": type
                        }
                    }
                })
            })
                .then(res => res.json())
                .then(json => {
                    this._loadedHybrids = true;
                    let genusMetaobject = json.data.metaobject;

                    for (let i = 0; i < genusMetaobject.fields.length; i++) {
                        let field = genusMetaobject.fields[i];

                        if (field.key === 'list_hybrids') {
                            for (let y = 0; y < field.references.edges.length; y++) {
                                let specie = field.references.edges[y].node;
                                this.hybridsListElement.appendChild(this.createSpecieHtml(specie));
                            }
                            this.updateShopIcons(this.hybridsListElement);
                        }
                    }
                }).catch(err => console.error(err));
        }

        async fetchAndRenderCultivars(cultivarIds, container) {
            let language = document.documentElement.lang.toUpperCase();
            const query = `
query GetCultivars($ids: [ID!]!) @inContext(language: `+ language +`) {
  nodes(ids: $ids) {
    ... on Metaobject {
      id
      handle
      type
      onlineStoreUrl
      fields {
        key
        value
        reference {
          ... on MediaImage {
            id
          }
        }
      }
    }
  }
}
            `;

            const res = await fetch(GRAPHQL_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
                },
                body: JSON.stringify({ query, variables: { ids: cultivarIds } })
            });

            const json = await res.json();
            const nodes = (json.data?.nodes || []).filter(Boolean);

            for (const node of nodes) {
                container.appendChild(this.createSpecieHtml(node, true));
            }
            this.updateShopIcons(container);
        }

        async updateShopIcons(container) {
            const items = [...container.querySelectorAll('specie-item[data-product-ids]')];
            if (!items.length) return;

            const allIds = [...new Set(items.flatMap(el => {
                try { return JSON.parse(el.dataset.productIds); } catch(e) { return []; }
            }))];

            const map = await this.fetchProductAvailability(allIds);

            for (const item of items) {
                try {
                    const ids = JSON.parse(item.dataset.productIds);
                    if (ids.some(id => map[id] === true)) {
                        item.querySelector('.icon-info-shop')?.style.removeProperty('display');
                    }
                } catch(e) {}
            }
        }

        async fetchProductAvailability(productIds) {
            if (!productIds.length) return {};

            const query = `
query GetProductAvailability($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
      id
      availableForSale
    }
  }
}
            `;

            try {
                const res = await fetch(GRAPHQL_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
                    },
                    body: JSON.stringify({ query, variables: { ids: productIds } })
                });

                const json = await res.json();
                const map = {};
                for (const node of json.data?.nodes || []) {
                    if (node?.id) map[node.id] = node.availableForSale;
                }
                return map;
            } catch(e) {
                return {};
            }
        }

        createSpecieHtml(specie, navigatesDirectly = false) {
            for (let x = 0; x < specie.fields.length; x++) {
                let specieField = specie.fields[x];
                specie[specieField.key] = specieField.value;
            }

            let productIds = [];
            if (specie.products) {
                try { productIds = JSON.parse(specie.products); } catch(e) {}
            }

            // Collect cultivar IDs (only for expandable items in the main list)
            let cultivarIds = [];
            if (!navigatesDirectly) {
                let i = 0;
                while (specie[`cultivars_${i}`] !== undefined) {
                    try { cultivarIds.push(...JSON.parse(specie[`cultivars_${i}`])); } catch(e) {}
                    i++;
                }
            }
            let hasCultivars = cultivarIds.length > 0;

            // header_image does not contain a reference to the image. So we did not manage to show it here.

            let onlineStoreUrl = specie.onlineStoreUrl;
            if (document.baseURI.indexOf('127.0.0.1') > -1) {
                onlineStoreUrl = onlineStoreUrl.replace('https://www.denmulderboomteelt.com', 'http://127.0.0.1:9292');
            }

            let titleHtml = document.createElement('h3');
            if (hasCultivars) {
                titleHtml.innerHTML = '<span>'+ specie.title +'</span>';
            } else {
                titleHtml.innerHTML = '<a href="'+ onlineStoreUrl +'">'+ specie.title +'</a>';
            }

            let titleContainerHtml = document.createElement('div');
            titleContainerHtml.appendChild(titleHtml);

            if (specie.common_title) {
                let commonTitleHtml = document.createElement('h4');
                commonTitleHtml.innerText = specie.common_title;
                titleContainerHtml.appendChild(commonTitleHtml);
            }

            let iconsContainerHtml = document.createElement('div');
            iconsContainerHtml.classList.add('specie-item-icons');

            let svgIconsContainerHtml = document.createElement('div');
            svgIconsContainerHtml.classList.add('info-icons');

            if (specie.fields.length > 10) {
                // When a product has only 10 fields this indicates a minimal filled specie
                svgIconsContainerHtml.appendChild(this.informationSvg.cloneNode(true));
            }

            if (productIds.length) {
                const shopIconEl = this.shopSvg.cloneNode(true);
                shopIconEl.style.display = 'none';
                svgIconsContainerHtml.appendChild(shopIconEl);
            }

            let buttonContainerHtml = document.createElement('div');
            if (hasCultivars) {
                buttonContainerHtml.innerHTML = '<span class="button button--primary">' + this.arrowSvg.outerHTML + '</span>';
            } else {
                buttonContainerHtml.innerHTML = '<a href="'+ onlineStoreUrl +'" class="button button--primary">' + this.arrowSvg.outerHTML + '</a>';
            }

            iconsContainerHtml.appendChild(svgIconsContainerHtml);
            iconsContainerHtml.appendChild(buttonContainerHtml);

            let contentHtml = document.createElement('div');
            contentHtml.classList.add('specie-item-content');
            contentHtml.appendChild(titleContainerHtml);
            contentHtml.appendChild(iconsContainerHtml);

            let specieItemHtml = document.createElement('specie-item');
            specieItemHtml.classList.add('specie-item');
            specieItemHtml.appendChild(contentHtml);
            if (productIds.length) {
                specieItemHtml.dataset.productIds = JSON.stringify(productIds);
            }

            if (!hasCultivars) {
                return specieItemHtml;
            }

            // Expandable: wrap specie-item + hidden cultivars container
            let cultivarsContainer = document.createElement('div');
            cultivarsContainer.classList.add('specie-cultivars');

            let cultivarsLoaded = false;
            specieItemHtml.style.cursor = 'pointer';
            specieItemHtml.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopPropagation();

                const willOpen = !cultivarsContainer.classList.contains('active');

                // Close all other open cultivar sections in the same parent
                const parentEl = wrapperHtml.parentElement;
                if (parentEl) {
                    parentEl.querySelectorAll('.specie-cultivars.active').forEach(el => {
                        if (el !== cultivarsContainer) el.classList.remove('active');
                    });
                    parentEl.querySelectorAll('.specie-item.active').forEach(el => {
                        if (el !== specieItemHtml) el.classList.remove('active');
                    });
                }

                cultivarsContainer.classList.toggle('active', willOpen);
                specieItemHtml.classList.toggle('active', willOpen);

                if (willOpen && !cultivarsLoaded) {
                    cultivarsLoaded = true;
                    cultivarsContainer.appendChild(this.createSpecieHtml(specie, true));
                    await this.fetchAndRenderCultivars(cultivarIds, cultivarsContainer).catch(console.error);
                }
            });

            let wrapperHtml = document.createElement('div');
            wrapperHtml.classList.add('specie-item-with-cultivars');
            wrapperHtml.appendChild(specieItemHtml);
            wrapperHtml.appendChild(cultivarsContainer);

            return wrapperHtml;
        }
    }
  );
}
